import { saveData } from 'containers/App/localStorageManager'
import { params } from 'config'

export const signOut = () => {
  saveData('userIsAuthenticated', false);
  saveData('user', {});
  saveData('company', {});
  window.location = `${params.COGNITO_LOGIN_URL}/signout?callbackUrl=${encodeURIComponent(window.location.href)}`;
}
